import { api } from "../../api"

//fetch page content
const fetchPageContent = async (slug) => {
    const url = `/page-data/${slug}`
    const response = await api.get(url)
    return response.data
}

const fetchTeamMembers = async (limit) => {
    const url = `/endowment-fund/team/${limit}`
    const response = await api.get(url)
    return response.data
}

const endowmentTeamService = {
    fetchPageContent,
    fetchTeamMembers,
}

export default endowmentTeamService
